var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status)?_c('span',{attrs:{"width":_vm.width || '1em',"height":_vm.height || '1em'}},[_vm._t("spinner"),_c('span',[_vm._v(_vm._s(_vm.message))])],2):_vm._e(),(!_vm.status)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }